// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"132":"plyr","374":"PhotoSwipeUI","799":"photoswipe"}[chunkId] || chunkId) + ".chunk.js";
};